import { Colors, Fonts } from '../../../shared/theme/';
import fonts from '../../../shared/theme/fonts';
import metrics from '../../../shared/theme/metrics';
import { textStyles } from '../../../shared/theme/fonts-ppv';

export default {
  defaultContent: {
    backgroundColor: Colors.white,
    padding: 20,
    minWidth: 'fit-content',
  } as React.CSSProperties,
  defaultContentNotFound: {
  } as React.CSSProperties,
  addBox: {
    justifyContent: 'flex-end',
    display: 'flex',
    alignItems: 'flex-end',
    padding: '16px'
  } as React.CSSProperties,
  boxAdd: {
    justifyContent: 'flex-end',
    display: 'flex',
    alignItems: 'flex-end',
    padding: '16px'
  } as React.CSSProperties,
  centerBox: {
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column'
  } as React.CSSProperties,
  tableBox: {
    paddingLeft: '16px',
    paddingRight: '16px',
    paddingTop: '32px',
  } as React.CSSProperties,
  rowBox: {
    display: 'flex',
    flexDirection: 'row',
  } as React.CSSProperties,
  cellBox: {


  } as React.CSSProperties,
  rangeBox: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    flexDirection: 'column',
    height: '20px',
    paddingTop: '10px',
    paddingBottom: '10px'
  } as React.CSSProperties,
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: metrics.base * 2,
    height: '56px'
  } as React.CSSProperties,
  selectedMenuItem: {
    backgroundColor: '#FCF4FA'
  },
  searchBox: {
    padding: '14px 10px'
  },
  addVatBox: {
    display: 'flex',
    flexDirection: 'row',
    cursor: 'pointer',
  },
  paddingHorizontal10: {
    paddingLeft: '10px',
    paddingRight: '10px'
  },
  paddingVertical10: {
    paddingTop: '10px',
    paddingBottom: '10px'
  },
  paddingStep2: {
    paddingTop: '10px',
    paddingBottom: '30px'
  },
  paddingTabVatAddress: {
    paddingBottom: '20px'
  },
  textRegular12Gray: {
     ...textStyles.body3,
    fontSize: Fonts.size.text12,
    color: Colors.font.primary.darkGray
  },
  buttonPos: {
    ...textStyles.subtitle2,
    color: Colors.lightPurple,
    borderColor: Colors.lightPurple,
    borderRadius: '4px',
    background: 'transparent',
    height: '40px',
    marginRight: '16px'
  },
  posIcon: {
    width: '14px',
    height: '16px',
    marginRight: '8px',
  },
  headerRemark: {
    marginBottom : '20px'
  } as React.CSSProperties,
  qcRejectBanner: {
    marginBottom : '20px',
  },
  qcRejectReason: {
    marginTop: metrics.baseMargin / 2
  },
  textRegular14DarkGray: {
     ...textStyles.body2,
    fontSize: Fonts.size.text14,
    color: Colors.font.primary.darkGray
  },
  textRegular14ErrorRed: {
    ...textStyles.body2,
    fontSize: Fonts.size.text14,
    color: Colors.font.messaging.errorRed
  },
  subTitleText: {
    ...textStyles.body2,
    color: Colors.font.primary.darkGray,
    marginBottom: metrics.base * 2
  }
};
